import { Formie } from "../../../vendor/verbb/formie/src/web/assets/frontend/src/js/formie-lib";

const formieInstance = new Formie();

export default formieInstance;